import { render, staticRenderFns } from "./AvalancheVictimTable.vue?vue&type=template&id=52e7c318"
import script from "./AvalancheVictimTable.vue?vue&type=script&lang=js"
export * from "./AvalancheVictimTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports